import { defineFetch } from 'resift';

interface TaskData {
  isComplete: boolean;
}

export default defineFetch({
  displayName: 'Update Onboarding Task',
  make: (taskId: string) => ({
    key: [],
    request: (data: TaskData) => ({ http }: any) =>
      http({
        method: 'PUT',
        route: `/onboarding-tasks/${taskId}`,
        data,
      }),
  }),
});
